import React from "react"
import "./Header.css"

function Header() {
    return (
        <h1>Rick and Morty Characters</h1>
    )
}

export default Header